import React from 'react'

const VerticalCardImageContainer: React.FC = props => {
    return <>{props.children}</>
}

export default VerticalCardImageContainer
